"use strict";
/*
 * Created on 06 27 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var UserMessageCode_1 = require("../../../user-messages/model/UserMessageCode");
/**
 * @author Jaroslav Sevcik
 */


var NewRecommendedPair =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(NewRecommendedPair, _EntityEventFlag_1$En);

  function NewRecommendedPair() {
    _classCallCheck(this, NewRecommendedPair);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewRecommendedPair).apply(this, arguments));
  }

  _createClass(NewRecommendedPair, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }]);

  return NewRecommendedPair;
}(EntityEventFlag_1.EntityEventFlag);

exports.NewRecommendedPair = NewRecommendedPair;
NewRecommendedPair.TAG = EntityEventFlag_1.EntityEventFlag.register(NewRecommendedPair);
NewRecommendedPair.INSTANCE = new NewRecommendedPair();
NewRecommendedPair.MESSAGE = ValidationResultObject_1.ValidationResultObject.of(ResultSeverity_1.ResultSeverity.Info, UserMessageCode_1.UserMessageCode.NewRecommendedPair);